export const appType: "oauthApp" | "githubApp" = "githubApp";
